'use strict';

import type { GlobCompanies } from '../../Entities/Glob/GlobCompanies';
import { EntityCollection } from '../EntityCollection';

export class GlobCompaniesCollection extends EntityCollection<GlobCompanies> {}
